import type {
  BinaryMessagePayload,
  InstanceInfo,
  JsonMessagePayload,
  RoomBroadcastPayload,
} from "@bezoned/desktop-bridge/events.js";
import { createContext } from "react";

type DesktopBridgeConnectionStatus =
  | "idle"
  | "connecting"
  | "connected"
  | "syncing"
  | "ready"
  | "waiting"
  | "reconnecting"
  | "disconnected";

interface DesktopBridgeContextType {
  __ctx_init: boolean;
  status: DesktopBridgeConnectionStatus;
  instanceId: string | null;
  instances: InstanceInfo[];
  desktopAppVersion: string | null;
  connect: () => void;
  disconnect: () => void;
  sendJson: (room: string, data: unknown) => void;
  sendBinary: (
    room: string,
    data: ArrayBuffer,
    mimeType: string,
    filename?: string
  ) => void;
  joinRoom: (room: string) => void;
  leaveRoom: (room: string) => void;
  broadcast: (room: string, data: unknown) => void;
  onJsonMessage: (handler: (payload: JsonMessagePayload) => void) => () => void;
  onBinaryMessage: (
    handler: (payload: BinaryMessagePayload) => void
  ) => () => void;
  onRoomBroadcast: (
    handler: (payload: RoomBroadcastPayload) => void
  ) => () => void;
}

const noop = () => {
  /* no-op */
};

const noopUnsub = () => noop;

export const DesktopBridgeContext = createContext<DesktopBridgeContextType>({
  __ctx_init: false,
  broadcast: noop,
  connect: noop,
  desktopAppVersion: null,
  disconnect: noop,
  instanceId: null,
  instances: [],
  joinRoom: noop,
  leaveRoom: noop,
  onBinaryMessage: noopUnsub,
  onJsonMessage: noopUnsub,
  onRoomBroadcast: noopUnsub,
  sendBinary: noop,
  sendJson: noop,
  status: "idle",
});
